import React from 'react';
import { useContent } from '../cms/content.js';

export default function Fee() {
  const cms = useContent();
  const packages = cms.fee.packages || [];
  const benefits = cms.fee.enterpriseBenefits || [];
  const enterpriseNote = cms.fee.enterpriseNote;

  // The center card is "The Discovery & Access" (isFeatured: true)
  const discoveryPkg = packages.find((pkg) => pkg.isFeatured) || packages[3];

  const hasBenefits = benefits.length > 0;
  const leftCount = Math.ceil(benefits.length / 2);
  const leftBenefits = benefits.slice(0, leftCount);
  const rightBenefits = benefits.slice(leftCount);

  return (
    <section id="fee"
      style={{
        position: 'relative',
        zIndex: 10,
        background: '#0a0a0b',
        borderTop: '1px solid rgba(201,168,106,0.14)',
        padding: '130px clamp(18px, 3vw, 32px)'
      }}>
      <div style={{ maxWidth: '1320px', margin: '0 auto', textAlign: 'center' }}>
        <div data-reveal="" style={{ marginBottom: '62px' }}>
          <div
            style={{
              font: "500 12px/1 'JetBrains Mono',monospace",
              letterSpacing: '0.34em',
              textTransform: 'uppercase',
              color: '#c9a86a',
              marginBottom: '24px'
            }}>
            {cms.fee.eyebrow}
          </div>
          <h2
            style={{
              margin: '0 auto 22px',
              fontFamily: "'Cormorant',serif",
              fontWeight: 400,
              fontSize: 'clamp(38px,5vw,64px)',
              lineHeight: '1.0',
              color: '#f5f0e6'
            }}>
            {cms.fee.headingLine1} {cms.fee.headingLine2}
          </h2>
          <p
            style={{
              margin: '0 auto',
              maxWidth: '620px',
              fontSize: '16px',
              lineHeight: 1.66,
              fontWeight: 300,
              color: '#8b8579'
                }}>
            {cms.fee.intro}
          </p>
        </div>

        {discoveryPkg && (
          hasBenefits ? (
            <div className="kny-enterprise-container" style={{ textAlign: 'left' }}>
              {/* Center featured column - rendered first in DOM for mobile first-paint/source-order */}
              <div className="kny-enterprise-col-center">
                <div
                  data-reveal=""
                  className="kny-card"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    border: '1px solid rgba(201,168,106,0.45)',
                    background: 'linear-gradient(180deg, #0d0e12, #0a0a0b)',
                    padding: 'clamp(38px, 4vw, 56px) clamp(30px, 3.5vw, 48px)',
                    boxShadow: '0 12px 42px rgba(201,168,106,0.06)',
                    height: '100%'
                  }}
                >
                  <div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        borderBottom: '1px solid rgba(201,168,106,0.16)',
                        paddingBottom: '22px',
                        marginBottom: '24px'
                      }}
                    >
                      <div>
                        <div
                          style={{
                            font: "500 14px/1.2 'JetBrains Mono',monospace",
                            letterSpacing: '0.12em',
                            textTransform: 'uppercase',
                            color: '#c9a86a',
                            marginBottom: '6px'
                          }}
                        >
                          {discoveryPkg.title}
                        </div>
                        <div
                          style={{
                            font: "500 10px/1.2 'JetBrains Mono',monospace",
                            letterSpacing: '0.08em',
                            textTransform: 'uppercase',
                            color: '#6f6a60'
                          }}
                        >
                          {discoveryPkg.subtitle}
                        </div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div
                          style={{
                            fontFamily: "'Cormorant',serif",
                            fontWeight: 500,
                            fontSize: '44px',
                            lineHeight: 0.9,
                            color: '#f5f0e6'
                          }}
                        >
                          {discoveryPkg.price}
                        </div>
                        {discoveryPkg.interval && (
                          <div
                            style={{
                              font: "500 9px/1.2 'JetBrains Mono',monospace",
                              letterSpacing: '0.04em',
                              textTransform: 'uppercase',
                              color: '#6f6a60',
                              marginTop: '6px'
                            }}
                          >
                            {discoveryPkg.interval}
                          </div>
                        )}
                      </div>
                    </div>

                    <p
                      style={{
                        margin: '0 0 24px',
                        fontSize: '15px',
                        lineHeight: 1.62,
                        fontWeight: 300,
                        color: '#8b8579'
                      }}
                    >
                      {discoveryPkg.description}
                    </p>

                    {enterpriseNote && (
                      <div
                        style={{
                          margin: '0 0 28px',
                          padding: '16px 20px',
                          borderLeft: '2px solid #c9a86a',
                          background: 'rgba(201,168,106,0.05)',
                          fontSize: '13.5px',
                          lineHeight: 1.55,
                          color: '#cfc9bc',
                          fontStyle: 'italic',
                          borderRadius: '0 2px 2px 0'
                        }}
                      >
                        {enterpriseNote}
                      </div>
                    )}

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '36px' }}>
                      {(discoveryPkg.included || []).map((text, idx) => (
                        <div key={idx} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                          <span style={{ color: '#c9a86a', font: "500 11px/1.4 'JetBrains Mono',monospace" }}>—</span>
                          <span style={{ fontSize: '14px', lineHeight: 1.48, fontWeight: 300, color: '#cfc9bc' }}>
                            {text}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div>
                    <a
                      href="#brief"
                      className="kny-cta"
                      style={{
                        display: 'block',
                        textAlign: 'center',
                        textDecoration: 'none',
                        background: '#c9a86a',
                        color: '#0a0a0b',
                        padding: '19px',
                        font: "500 11px/1 'JetBrains Mono',monospace",
                        letterSpacing: '0.18em',
                        textTransform: 'uppercase',
                        borderRadius: '2px'
                      }}
                    >
                      {discoveryPkg.ctaLabel || 'Begin your brief →'}
                    </a>
                    {discoveryPkg.finePrint && (
                      <p
                        style={{
                          margin: '18px 0 0',
                          textAlign: 'center',
                          font: "500 9px/1.4 'JetBrains Mono',monospace",
                          letterSpacing: '0.1em',
                          textTransform: 'uppercase',
                          color: '#6f6a60'
                        }}
                      >
                        {discoveryPkg.finePrint}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Left benefits column */}
              <div className="kny-enterprise-col-left kny-enterprise-benefits-col">
                {leftBenefits.map((b, idx) => (
                  <div key={idx} className="kny-benefit-card" data-reveal="">
                    <div className="kny-benefit-title" style={{ color: '#c9a86a' }}>{b.title}</div>
                    <p className="kny-benefit-body">{b.body}</p>
                  </div>
                ))}
              </div>

              {/* Right benefits column */}
              <div className="kny-enterprise-col-right kny-enterprise-benefits-col">
                {rightBenefits.map((b, idx) => (
                  <div key={idx} className="kny-benefit-card" data-reveal="">
                    <div className="kny-benefit-title" style={{ color: '#c9a86a' }}>{b.title}</div>
                    <p className="kny-benefit-body">{b.body}</p>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div style={{ maxWidth: '680px', margin: '0 auto', textAlign: 'left' }}>
              <div
                data-reveal=""
                className="kny-card"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  border: '1px solid rgba(201,168,106,0.45)',
                  background: 'linear-gradient(180deg, #0d0e12, #0a0a0b)',
                  padding: 'clamp(38px, 4vw, 56px) clamp(30px, 3.5vw, 48px)',
                  boxShadow: '0 12px 42px rgba(201,168,106,0.06)'
                }}
              >
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      borderBottom: '1px solid rgba(201,168,106,0.16)',
                      paddingBottom: '22px',
                      marginBottom: '24px'
                    }}
                  >
                    <div>
                      <div
                        style={{
                          font: "500 14px/1.2 'JetBrains Mono',monospace",
                          letterSpacing: '0.12em',
                          textTransform: 'uppercase',
                          color: '#c9a86a',
                          marginBottom: '6px'
                        }}
                      >
                        {discoveryPkg.title}
                      </div>
                      <div
                        style={{
                          font: "500 10px/1.2 'JetBrains Mono',monospace",
                          letterSpacing: '0.08em',
                          textTransform: 'uppercase',
                          color: '#6f6a60'
                        }}
                      >
                        {discoveryPkg.subtitle}
                      </div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div
                        style={{
                          fontFamily: "'Cormorant',serif",
                          fontWeight: 500,
                          fontSize: '44px',
                          lineHeight: 0.9,
                          color: '#f5f0e6'
                        }}
                      >
                        {discoveryPkg.price}
                      </div>
                      {discoveryPkg.interval && (
                        <div
                          style={{
                            font: "500 9px/1.2 'JetBrains Mono',monospace",
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            color: '#6f6a60',
                            marginTop: '6px'
                          }}
                        >
                          {discoveryPkg.interval}
                        </div>
                      )}
                    </div>
                  </div>

                  <p
                    style={{
                      margin: '0 0 24px',
                      fontSize: '15px',
                      lineHeight: 1.62,
                      fontWeight: 300,
                      color: '#8b8579'
                    }}
                  >
                    {discoveryPkg.description}
                  </p>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '36px' }}>
                    {(discoveryPkg.included || []).map((text, idx) => (
                      <div key={idx} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                        <span style={{ color: '#c9a86a', font: "500 11px/1.4 'JetBrains Mono',monospace" }}>—</span>
                        <span style={{ fontSize: '14px', lineHeight: 1.48, fontWeight: 300, color: '#cfc9bc' }}>
                          {text}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <a
                    href="#brief"
                    className="kny-cta"
                    style={{
                      display: 'block',
                      textAlign: 'center',
                      textDecoration: 'none',
                      background: '#c9a86a',
                      color: '#0a0a0b',
                      padding: '19px',
                      font: "500 11px/1 'JetBrains Mono',monospace",
                      letterSpacing: '0.18em',
                      textTransform: 'uppercase',
                      borderRadius: '2px'
                    }}
                  >
                    {discoveryPkg.ctaLabel || 'Begin your brief →'}
                  </a>
                  {discoveryPkg.finePrint && (
                    <p
                      style={{
                        margin: '18px 0 0',
                        textAlign: 'center',
                        font: "500 9px/1.4 'JetBrains Mono',monospace",
                        letterSpacing: '0.1em',
                        textTransform: 'uppercase',
                        color: '#6f6a60'
                      }}
                    >
                      {discoveryPkg.finePrint}
                    </p>
                  )}
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </section>
  );
}
